import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import cx from 'classnames';
import Link from './Link';
import Image from './Image';
import Content from './Content';

export const Hero = ({ hero, contentComponent }) => {
  const PageContent = contentComponent || Content; // needed to cooperate with Netlify CMS preview
  const type = hero.type || 'image';
  const narrow = hero.type === 'state' || hero.type === 'text';
  const imageOnly = hero.image && !hero.header && !hero.description;
  let colSizes = hero.col_sizes || [7, 5];
  if (type === 'text') {
    colSizes = [12];
  }

  // the CMS sometimes leaves us with a hero header "" when a hero has been removed.
  if (!hero.header && !hero.description && !imageOnly) {
    return null;
  }

  return (
    <Container>
      <div
        className={cx(
          { 'text-container mx-auto': narrow },
          'top-section section'
        )}
      >
        <Row className="mb-3">
          {type !== 'text' && (
            <Col
              xs={{ size: 12, order: 1 }}
              md={{ size: colSizes[0], order: 2 }}
              className={cx({
                'mx-auto': imageOnly,
              })}
            >
              {type === 'image' && hero.image && (
                <Image className="hero-image mb-6 mb-md-0" image={hero.image} />
              )}
              {type === 'state' && (
                <div
                  className={`sf-${hero.meta.toLowerCase()} state-icon-hero text-md-right text-center`}
                />
              )}
            </Col>
          )}
          {(hero.header || hero.description) && (
            <Col
              xs={{ size: 12, order: 2 }}
              md={{ size: colSizes[1], order: 1 }}
            >
              <h1 className={cx('text-uppercase mb-3')}>{hero.header}</h1>
              <div className={cx({ 'mb-5': hero.call_to_action })}>
                {
                  <PageContent
                    className="page-content"
                    content={hero.description}
                  />
                }
              </div>
              {hero.call_to_action && (
                <Link
                  to={hero.call_to_action_url}
                  className="btn btn-primary btn-important"
                >
                  {hero.call_to_action}
                </Link>
              )}
            </Col>
          )}
        </Row>
      </div>
    </Container>
  );
};

export default Hero;
